import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useCachedPatientUpdateSimple } from "../../hooks/useCachedPatientUpdateSimple";

const PatientAccountUpdate: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const { patient, loading, error } = useCachedPatientUpdateSimple(id || null);
  
  const handleBack = () => {
    navigate("/admin/dashboard/account/patient");
  };

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (error) {
    return <div>Erreur: {error}</div>;
  }

  if (!patient) {
    return <div>Patient non trouvé</div>;
  }

  return (
    <div className="p-6">
      <div className="mb-4">
        <button 
          onClick={handleBack}
          className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
        >
          Retour
        </button>
      </div>
      
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold mb-4">Mettre à jour le compte patient</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Nom</label>
            <input 
              type="text" 
              defaultValue={patient.lastName || ""}
              className="w-full p-2 border rounded"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">Prénom</label>
            <input 
              type="text" 
              defaultValue={patient.firstName || ""}
              className="w-full p-2 border rounded"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input 
              type="email" 
              defaultValue={patient.email || ""}
              className="w-full p-2 border rounded"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">Téléphone</label>
            <input 
              type="tel" 
              defaultValue={patient.phone || ""}
              className="w-full p-2 border rounded"
            />
          </div>
        </div>
        
        <div className="mt-6">
          <button 
            type="submit"
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Mettre à jour
          </button>
        </div>
      </div>
    </div>
  );
};

export default PatientAccountUpdate;
